import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { atelierSulphurpoolLight } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import { Anchor, } from 'UI-Dash-Commons-UI'

export enum IndentWidthType
{
    NONE,
    XXSMALL,
    XSMALL,
    SMALL,
    MEDIUM,
    LARGE,
    XLARGE
}

export interface PageContentProps
{
    text?: string,
    withIndent?: IndentWidthType,
    className?: string,
}

const DocsPageContent: FunctionComponent<PageContentProps> = ( {
                                                                   text = '',
                                                                   withIndent = IndentWidthType.NONE,
                                                                   className,
                                                                   children
                                                               } ) =>
{
    // TODO: refactor in Commons-UI or Docs-Commons
    // transform any special text characters
    const transformedText = text.split( ' ' ).map( ( word: string, index: number ) =>
    {
        // transform code snippets
        if ( word.match( /`\S*`/g ) ) // captures all non-whitespace characters
        {
            word = word.replace( /`/g, '' );
            return <DocsPageContentCode key={index} children={word} language={'text'} style={atelierSulphurpoolLight}/>;
        }
        // transform links
        else if ( word.match( /\[(.*?)]/g ) ) // captures all text within [] brackets
        {
            const link = word.substring( word.indexOf( '(' ) + 1, word.indexOf( ')' ) );
            word = word.substring( word.indexOf( '[' ) + 1, word.indexOf( ']' ) );
            return <DocsPageContentLink key={index} text={word} href={link} target={'_blank'}
                                        rel={'noopener noreferrer'}/>
        }
        // transform list items
        else if ( word.match( /^((•)|(\d+\.)$)/ ) )
        {
            return <DocsPageContentListItem key={index} text={word}/>;
        }
        // transform rest
        else
        {
            return word + ' '; // add a buffer space for spacing in between words
        }
    } );

    return <DocsPageContentWrapper withIndent={withIndent} className={className}>

        {transformedText}

        {children}

    </DocsPageContentWrapper>;
};

export default DocsPageContent;

const DocsPageContentWrapper = styled.span<{ withIndent: IndentWidthType }>`
  display: block;
  
  margin: ${props => props.withIndent === IndentWidthType.NONE && '20px 0px'};

  padding-left: 0px;
  padding-left: ${props => props.withIndent === IndentWidthType.NONE && '0px'};
  padding-left: ${props => props.withIndent === IndentWidthType.SMALL && '50px'};
  padding-left: ${props => props.withIndent === IndentWidthType.MEDIUM && '100px'};
  padding-left: ${props => props.withIndent === IndentWidthType.LARGE && '150px'};
  padding-left: ${props => props.withIndent === IndentWidthType.XLARGE && '200px'};

  font-family: ${props => props.theme.fonts.regular};

  font-size: 16px;
  line-height: 20px;

  color: ${props => props.theme.colors.blackLight};
`;

const DocsPageContentCode = styled( SyntaxHighlighter )`
  display: inline !important;

  margin-right: 3px !important;
  padding: 1px 5px !important;

  font-size: 15px;

  border-radius: 4px;
`;

const DocsPageContentListItem = styled.span<{ text: string }>`
  ::before {
    content: "${props => props.text}";
    margin-right: 15px;
  }
`;

const DocsPageContentLink = styled( Anchor )`
  display: inline !important;

  margin-right: 3px !important;

  font-size: 16px;
`;
